interface StatContent {
  numericValue?: string;
  description?: string;
  pageTitle?: string;
  pageId?: number | string;
  link?: {
    href: string;
    text: string;
  };
  statSubjects?: any[];
}

interface StatItemProps {
  content: StatContent;
  file: any;
  viewMode?: 'grid' | 'list';
}

const StatItem: React.FC<StatItemProps> = ({ content, viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <div className="flex h-[160px] items-center gap-4 border border-gray-200 bg-white">
        <div className="relative h-full w-[315px] cursor-pointer border-r border-gray-300 bg-gray-50 px-[10px] py-0">
          <div className="relative flex h-full items-center justify-center p-0">
            <div
              className="absolute -top-[0px] -left-[0px] z-[2] text-[3.75rem] font-bold"
              style={{ color: '#e0e0e0' }}
            >
              {content?.numericValue}
            </div>
            <div className="relative z-[4] line-clamp-4 overflow-hidden text-left text-[16px] text-black">
              {content?.description}
            </div>
          </div>
        </div>
        <div className="relative bottom-5 flex-1 cursor-pointer">
          <h4 className="font-bold text-gray-900">Stat</h4>
          <div className="mt-1 text-xs text-black">
            <div className="line-clamp-3 overflow-hidden">{content?.pageTitle}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        className="cntr relative h-0 w-full cursor-pointer overflow-hidden border border-gray-300 bg-gray-50 pt-[30px]"
        style={{ paddingBottom: '73.25%' }}
      >
        <div className="absolute top-4 right-4 bottom-4 left-4">
          <div className="extractContent relative h-full w-full">
            <div
              className="numericValue absolute -top-[25px] -left-[10px] z-[2] text-[3.75rem] font-bold"
              style={{ color: '#e0e0e0' }}
            >
              {content?.numericValue}
            </div>
            <div className="description absolute top-3 z-[4] line-clamp-6 overflow-hidden text-left text-[16px] break-words text-black">
              {content?.description}
            </div>
          </div>
        </div>
      </div>
      <div className="ifno h-[120px] border border-t-0 border-gray-300 bg-white p-3">
        <h4 className="font-bold">Stat</h4>
        <div className="lnk mt-1 text-xs">{content?.pageTitle}</div>
      </div>
    </div>
  );
};

export default StatItem;
